<template>
	<div>
		<v-data-table
			v-model:items-per-page="itemsPerPage"
			:headers="headers"
			:items="flights"
			><template v-slot:item.depTime="{ item }"
				><td>
					{{ moment(item.columns.depTime).format("DD.MM.YYYY") }}
				</td> </template
			><template v-slot:item.off="{ item }"
				><td>
					{{ moment(item.columns.off).format("HH:mm") }}
				</td> </template
			><template v-slot:item.on="{ item }"
				><td>
					{{ moment(item.columns.on).format("HH:mm") }}
				</td>
			</template>
			<template v-slot:item.total="{ item }"
				><td>
					{{ formatMs(moment.duration(item.columns.total).as("milliseconds")) }}
				</td>
			</template>
		</v-data-table>
		Total Time:
		{{ formatMs(moment.duration(this.totals.total_time).as("milliseconds"))
		}}<br />
		PIC Time:
		{{ formatMs(moment.duration(this.totals.pic_time).as("milliseconds"))
		}}<br />
		Dual Time:
		{{ formatMs(moment.duration(this.totals.dual_time).as("milliseconds"))
		}}<br />
	</div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import moment from "moment";
import { VDataTable } from "vuetify/labs/VDataTable";
import formatMs from "@/utils/formatMs";

export default {
	computed: {
		...mapState({
			token: "token",
		}),
	},
	components: {
		VDataTable,
	},
	data() {
		return {
			flights: [],
			itemsPerPage: 5,
			headers: [
				{
					title: "Date",
					align: "start",
					value: "departure_time",
					key: "depTime",
				},
				{
					title: "Plane",
					align: "start",
					value: "plane.callsign",
					key: "plane",
				},
				{
					title: "Departure",
					align: "start",
					value: "departure_airport.ident",
					key: "dep",
				},
				{
					title: "Arrival",
					align: "start",
					value: "arrival_airport.ident",
					key: "arr",
				},
				{
					title: "Off-Block",
					align: "start",
					value: "departure_time",
					key: "off",
				},
				{
					title: "On-Block",
					align: "start",
					value: "arrival_time",
					key: "on",
				},
				{
					title: "Total Time",
					align: "start",
					value: "total_time",
					key: "total",
				},
			],

			totals: "",
			clicked: "",
			loading: [],
		};
	},
	mounted() {
		this.getTable();
	},
	created() {
		this.moment = moment;
		this.formatMs = formatMs;
	},
	methods: {
		updateTable() {
			this.getTable();
		},
		getTable() {
			axios
				.get(process.env.VUE_APP_BACKEND_URL + "/flight", {
					headers: {
						Authorization: "bearer " + this.token,
					},
				})
				.then((response) => {
					this.flights = response.data;
					console.log(response.data);
				})
				.catch((e) => {
					console.error(e);
				});
			axios
				.get(process.env.VUE_APP_BACKEND_URL + "/flight/totals", {
					headers: {
						Authorization: "bearer " + this.token,
					},
				})
				.then((response) => {
					this.totals = response.data;
					console.log(response.data);
				})
				.catch((e) => {
					console.error(e);
				});
		},
	},
};
</script>

<style></style>
